import { AlertTriangle, LucideIcon, RefreshCw } from 'lucide-react';
import { Button } from './button';
import { cn } from '@/lib/utils';

interface ErrorStateProps {
  icon?: LucideIcon;
  title?: string;
  message?: string;
  retryAction?: () => void;
  className?: string;
}

export function ErrorState({
  icon: Icon = AlertTriangle,
  title = 'Something went wrong',
  message = 'We encountered an error while loading this content.',
  retryAction,
  className,
}: ErrorStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center text-destructive animate-in fade-in-50',
        className
      )}
    >
      <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
        <Icon className="h-6 w-6 text-destructive" />
      </div>
      <p className="font-medium text-lg text-foreground">{title}</p>
      <p className="text-sm text-muted-foreground mt-1 max-w-sm mb-4">{message}</p>
      {retryAction && (
        <Button onClick={retryAction} variant="outline" className="gap-2">
          <RefreshCw className="h-4 w-4" />
          Try Again
        </Button>
      )}
    </div>
  );
}
